var exports = {
  "Kk": "VoiceSettingsMenus.module__icon___bThyb2",
  "XK": "VoiceSettingsMenus.module__leadingActionLabel___bThyb2",
  "CS": "VoiceSettingsMenus.module__inputLevelItem___bThyb2",
  "lL": "VoiceSettingsMenus.module__inputLevelLabel___bThyb2",
  "_A": "VoiceSettingsMenus.module__inputLevelMeter___bThyb2",
};

module.exports = exports;
